import React, { useMemo } from "react";
import { Line } from "react-chartjs-2";
import { useTranslation } from "react-i18next";

const MonthlyDonorsChart = ({ data }) => {
  const { t } = useTranslation();

  const chartData = useMemo(() => {
    if (!data || !Array.isArray(data.months) || data.months.length === 0) return null;

    return {
      labels: data.months,
      datasets: [
        {
          label: t("Registered"),
          data: data.registered,
          borderColor: "#3b4cb8",
          backgroundColor: "rgba(59, 76, 184, 0.1)",
          fill: true,
          tension: 0.4,
          pointRadius: 4,
          pointHoverRadius: 6,
        },
        {
          label: t("Visited"),
          data: data.visited,
          borderColor: "#28a745",
          backgroundColor: "rgba(40, 167, 69, 0.1)",
          fill: true,
          tension: 0.4,
          pointRadius: 4,
          pointHoverRadius: 6,
        },
      ],
    };
  }, [data, t]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: true,
      position: "top",
      labels: {
        fontColor: "#666",
        usePointStyle: true,
      },
    },
    tooltips: {
      mode: "index",
      intersect: false,
      callbacks: {
        label: (tooltipItem, chartData) => {
          const datasetLabel = chartData.datasets[tooltipItem.datasetIndex].label;
          return `${datasetLabel}: ${tooltipItem.yLabel} ${t("donors")}`;
        },
      },
    },
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            fontColor: "#999",
          },
          scaleLabel: {
            display: true,
            labelString: t("Number of Donors"),
            fontColor: "#666",
          },
        },
      ],
      xAxes: [
        {
          ticks: {
            fontColor: "#999",
          },
          scaleLabel: {
            display: true,
            labelString: t("Month"),
            fontColor: "#666",
          },
        },
      ],
    },
  };

  if (!chartData) {
    return <p className="text-center mt-3">{t("No data available")}</p>;
  }

  return (
    <div style={{ minHeight: "290px" }}>
      <Line data={chartData} height={290} options={options} />
    </div>
  );
};

export default MonthlyDonorsChart;
